import { eventEmitter } from './chatuiEvents';
import { dispatchTrack } from './tracking';
import { COUNTRY } from '@/utils/locale';
import intl from '@/utils/i18n';

export const getChatUIProviderConfig = () => {
  return {
    eventEmitter: eventEmitter,
    tracker: { dispatchTrack: (params: any) => dispatchTrack({ ...params, reportdbOnly: true }) },
    region: COUNTRY,
    locales: intl.getCurrentLocale(),
  };
};
